export const webshop = {
  seo: {
    title: 'Boutique en ligne pour restaurants – Vente à emporter & livraison | Bistroo',
    description: "Une boutique en ligne personnalisée pour votre restaurant, entièrement adaptable à vos besoins. Essayez gratuitement pendant 30 jours.",
  },
  hero: {
    title: {
      pt1: 'Une',
      pt2: 'boutique en ligne',
      pt3: 'sur mesure pour les restaurants',
    },
    description:
      'Simplifiez-vous la vie avec la boutique Bistroo. Nos clients gagnent du temps, travaillent plus efficacement et voient leurs revenus augmenter.',
  },
  paragraphs: {
    paragraph_1: {
      title: 'Augmentez votre chiffre d\'affaires, réduisez vos coûts',
      text: 'Une boutique en ligne bien optimisée peut générer plus de commandes et des valeurs de commande plus élevées par rapport aux méthodes de commande traditionnelles. Économisez jusqu\'à 20 % sur les coûts et le temps opérationnels, et traitez plus de commandes que jamais.',
      cta: 'Explorer les formules Bistroo',
    },
    paragraph_2: {
      title: 'Payez seulement après avoir goûté à la valeur ajoutée',
      text: 'Des formules entièrement gratuites aux abonnements mensuels accessibles, choisissez le forfait qui correspond à vos goûts et découvrez par vous-même ce que les produits Bistroo peuvent faire pour vous. Grâce à une période d\'essai gratuite, vous pouvez facilement essayer sans être immédiatement lié par un contrat.',
      cta: '',
    },
    paragraph_3: {
      title: 'Commander via Google',
      text: 'Nous vous mettons littéralement sur la carte. Nous optimisons votre boutique pour la recherche Google et Google Maps. Nous suivons les innovations dans le domaine du trafic en ligne et veillons à ce que votre boutique reste toujours facile à trouver. Cette option est incluse dans toutes les formules Bistroo.',
      cta: 'Explorer les formules Bistroo',
    },
    paragraph_4: {
      title: 'Personnalisez selon votre marque',
      text: 'Un forfait white-label complet est disponible, vous permettant de façonner l\'ensemble de l\'expérience client dans le style de votre restaurant. De la page d\'accueil au processus de commande et de confirmation. Tout dans votre style unique.',
      cta: '',
    },
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Traitez les commandes sans effort.',
        text: 'Gérez chaque commande dans les moindres détails, partout et à tout moment, depuis n\'importe quel appareil. Imprimez des tickets comme vous le souhaitez, sur n\'importe quel type d\'imprimante.',
        button: '',
        img_alt: '',
      },
      card_2: {
        title: 'Intégrations.',
        text: 'Connectez votre système de caisse ou vos outils externes préférés.',
        button: '',
        img_alt: '',
      },
      card_3: {
        title: 'Options d\'upselling.',
        text: 'Configurez des options d\'upsell étendues et augmentez la valeur moyenne des commandes.',
        button: '',
        img_alt: '',
      },
      card_4: {
        title: 'Augmentez votre chiffre d\'affaires.',
        text: 'Jusqu\'à 30 % de chiffre d\'affaires supplémentaire avec une boutique optimisée.',
        button: '',
        img_alt: '',
      },
      card_5: {
        title: 'Remises et fidélité.',
        text: 'Configurez des promotions, des remises et des récompenses de fidélité pour vos clients réguliers.',
        button: '',
        img_alt: '',
      },
    },
  },
  testimonial: {
    text: '"Depuis que nous travaillons avec Bistroo, nous voyons nos commandes à emporter augmenter, super ! Quand quelque chose ne va pas bien, Bistroo est facile à joindre et règle tout immédiatement."',
    cta: 'Lire l\'histoire complète',
    name: 'Marieke van Loon',
    job_title: 'Propriétaire Xtra-social',
  },
  faq: {
    title_pt1: 'Tout sur le',
    title_pt2: 'Bistroo Webshop',
    items: [
      { q: 'Comment créer une boutique Bistroo ?', a: 'Inscrivez-vous gratuitement via merchant.bistroo.nl. Après votre inscription, vous effectuez une configuration rapide dans laquelle vous saisissez votre menu, vos horaires d\'ouverture et vos zones de livraison. En quelques minutes, votre boutique est en ligne.' },
      { q: 'Puis-je entièrement personnaliser la boutique à ma charte graphique ?', a: 'Oui. Vous choisissez vos propres couleurs, téléchargez votre logo et votre photo de profil, et définissez un message de bienvenue. Vous souhaitez aller plus loin ? Avec la formule white-label, vous gérez l\'ensemble de l\'expérience client dans le style de votre marque, de la page d\'accueil à la confirmation de commande.' },
      { q: 'Quels modes de paiement mes clients peuvent-ils utiliser ?', a: 'Via Bistroo, les clients peuvent payer avec iDEAL, carte de crédit, Apple Pay, Google Pay et plus encore. Vous connectez votre propre prestataire de paiement (Mollie ou Stripe) et les paiements arrivent directement sur votre compte.' },
      { q: 'Comment être trouvé via Google ?', a: 'Bistroo optimise votre boutique pour Google Search et Google Maps. Via Order with Google, un bouton de commande apparaît directement dans les résultats de recherche, afin que les clients commandent chez vous sans détour.' },
      { q: 'Puis-je configurer des remises et des actions de fidélité ?', a: 'Oui. Dans le Bistroo Manager, vous configurez facilement des codes de réduction, des promotions temporaires et des récompenses de fidélité. Ceux-ci sont directement visibles dans votre boutique.' },
      { q: 'La boutique peut-elle être connectée à mon système de caisse ?', a: 'Oui. Bistroo s\'intègre avec les systèmes de caisse les plus utilisés comme Lightspeed, unTill, M+ Kassa, WinstonPOS et Cashdesk. Les commandes arrivent automatiquement comme tickets dans votre caisse.' },
      { q: 'Comment configurer mes zones de livraison et d\'enlèvement ?', a: 'Via le Bistroo Manager, vous tracez précisément vos zones de livraison sur Google Maps. Par zone, vous configurez des frais de livraison et des montants minimum de commande séparés. Les modifications sont immédiatement en ligne.' },
      { q: 'Quel est le coût de la boutique Bistroo ?', a: 'Bistroo propose une formule gratuite pour démarrer immédiatement. Si vous souhaitez plus de fonctionnalités, des formules mensuelles payantes sont disponibles. Pas de frais de démarrage et pas de contrats à long terme.' },
      { q: 'Puis-je gérer plusieurs établissements depuis un seul compte ?', a: 'Oui. Via le Bistroo Manager, vous gérez tous vos établissements de manière centralisée. Pour chaque établissement, vous configurez des menus, des horaires d\'ouverture et des zones de livraison séparés.' },
      { q: 'Combien de temps faut-il pour mettre ma boutique en ligne ?', a: 'Dans la plupart des restaurants, la boutique est opérationnelle en une journée. Bistroo propose un accompagnement à l\'intégration afin que vous démarriez rapidement et sans erreurs.' },
    ],
  },
}
